module.exports = __webpack_public_path__ + "static/seller/img/zx-banner.21e44da9.png";